var _g, _rect, _rect2, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 72,
    viewBox: "0 0 108 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90.7429 15.1698C78.7537 11.7717 73.1094 18.9828 54.7563 11.281C40.1604 5.1428 31.2982 13.6262 28.0058 19.333C26.4377 22.0682 23.6349 33.5673 31.9071 35.5982C60.1004 42.5957 76.1226 77.6996 95.6673 54.6316C103.739 45.2868 117.948 22.7378 90.7429 15.1698Z",
    fill: "#B198F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_504_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5401 15.8398H30.0001C27.5811 15.8398 25.6201 17.8008 25.6201 20.2198V51.8398C25.6201 54.2589 27.5811 56.2198 30.0001 56.2198H87.5401C89.9591 56.2198 91.9201 54.2589 91.9201 51.8398V20.2198C91.9201 17.8008 89.9591 15.8398 87.5401 15.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5401 15.8398H30.0001C27.5811 15.8398 25.6201 17.8008 25.6201 20.2198V51.8398C25.6201 54.2589 27.5811 56.2198 30.0001 56.2198H87.5401C89.9591 56.2198 91.9201 54.2589 91.9201 51.8398V20.2198C91.9201 17.8008 89.9591 15.8398 87.5401 15.8398Z",
    stroke: "#B198F8",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 21,
    width: 30,
    height: 30,
    rx: 1,
    fill: "#F4EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2165 41C65.5375 41 65 40.434 65 39.7518V32.2482C65 31.5515 65.5517 31 66.2165 31H76.7835C77.4625 31 78 31.566 78 32.2482V39.7518C78 40.4485 77.4483 41 76.7835 41H66.2165ZM66.4146 33.9173C66.4146 34.73 67.0511 35.3832 67.8292 35.3832C68.6072 35.3832 69.2579 34.73 69.2579 33.9173C69.2579 33.1045 68.6213 32.4659 67.8292 32.4659C67.037 32.4659 66.4146 33.119 66.4146 33.9173ZM76.3732 39.3309V36.4136L74.1523 34.135C74.0392 34.0189 73.8411 34.0189 73.728 34.135L70.2905 37.6618L68.876 36.2105C68.7628 36.0943 68.5647 36.0943 68.4516 36.2105L66.6409 38.0682V39.3164H76.3874L76.3732 39.3309Z",
    fill: "#B397F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 27,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#B397F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 33,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#F4EFFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 38,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#F4EFFE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 43,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#F4EFFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_504_6",
    x: 9.62012,
    y: -0.160156,
    width: 98.2998,
    height: 72.3799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0666667 0 0 0 0 0.309804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_504_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_504_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.80a62c0aa054bd04ec089aa687d8126b.svg";
export { ForwardRef as ReactComponent };